import { render } from "./MonitoringList.vue?vue&type=template&id=dd4b2886&scoped=true"
import script from "./MonitoringList.vue?vue&type=script&lang=js"
export * from "./MonitoringList.vue?vue&type=script&lang=js"

import "./MonitoringList.vue?vue&type=style&index=0&id=dd4b2886&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-dd4b2886"]])

export default __exports__